import React from 'react';
export function FoxLogo({
  className = 'w-8 h-8'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-1715">
      <path d="M50 90L20 60C10 50 10 30 25 20C35 13 45 20 50 30C55 20 65 13 75 20C90 30 90 50 80 60L50 90Z" fill="url(#fox-gradient)" data-id="element-1716" />
      <path d="M25 20L15 5L35 15C30 18 27 20 25 20Z" fill="#EA580C" data-id="element-1717" />
      <path d="M75 20L85 5L65 15C70 18 73 20 75 20Z" fill="#EA580C" data-id="element-1718" />
      <path d="M50 75L35 55C40 55 45 60 50 65C55 60 60 55 65 55L50 75Z" fill="#FFF7ED" data-id="element-1719" />
      <circle cx="35" cy="45" r="4" fill="#0F172A" data-id="element-1720" />
      <circle cx="65" cy="45" r="4" fill="#0F172A" data-id="element-1721" />
      <circle cx="50" cy="60" r="3" fill="#0F172A" data-id="element-1722" />
      <defs data-id="element-1723">
        <linearGradient id="fox-gradient" x1="50" y1="20" x2="50" y2="90" gradientUnits="userSpaceOnUse" data-id="element-1724">
          <stop stopColor="#F97316" data-id="element-1725" />
          <stop offset="1" stopColor="#EA580C" data-id="element-1726" />
        </linearGradient>
      </defs>
    </svg>;
}